import { Link } from "react-router-dom";
import PageMeta from "@/components/base/PageMeta";
import JsonLd from "@/components/base/JsonLd";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import AnchorNav from "@/pages/home/components/AnchorNav";
import FocusSection from "@/pages/home/components/FocusSection";
import HotRankSection from "@/pages/home/components/HotRankSection";
import DailySection from "@/pages/home/components/DailySection";
import TopicSection from "@/pages/home/components/TopicSection";
import WeeklySection from "@/pages/home/components/WeeklySection";
import VoiceSection from "@/pages/home/components/VoiceSection";
import FaqSection from "@/pages/home/components/FaqSection";
import { homeFaqList } from "@/mocks/faq";
import { siteInfo } from "@/mocks/site";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: siteInfo.name,
  alternateName: "爆料吃瓜每日合集",
  url: "https://dearyuan.cn/",
  description: siteInfo.intro,
  inLanguage: "zh-CN",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://dearyuan.cn/daily?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: siteInfo.name,
  url: "https://dearyuan.cn/",
  email: siteInfo.email,
  description: siteInfo.intro,
  foundingDate: siteInfo.since,
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: homeFaqList.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: { "@type": "Answer", text: item.answer },
  })),
};

export default function Home() {
  return (
    <>
      <PageMeta
        title="瓜田日报｜爆料吃瓜每日合集，轻松一键速览爆料吃瓜热门盘点"
        description="爆料吃瓜每日合集准时上线，热门盘点一周热点，事件汇总吃瓜焦点，明星网红大瓜小瓜一网打尽，看这篇就够，吃瓜群众不用再翻遍全网。"
        keywords="爆料吃瓜,爆料吃瓜每日合集,爆料吃瓜热门盘点,爆料吃瓜事件汇总,娱乐话题速览"
        canonical="/"
      />
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <JsonLd data={faqSchema} />

      <SiteHeader overlay />

      <main id="top">
        <HeroSection />
        <AnchorNav />

        <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
          <div className="flex flex-col gap-16 pt-14 md:gap-24 md:pt-20">
            <FocusSection />
            <HotRankSection />
            <DailySection />
            <TopicSection />
            <WeeklySection />
          </div>

          <VoiceSection />

          <div className="pt-16 md:pt-24">
            <FaqSection />
          </div>

          <section className="mt-16 overflow-hidden rounded-card border border-accent-300/60 bg-accent-50 px-6 py-12 md:mt-24 md:px-12 md:py-16">
            <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
              <div className="max-w-xl">
                <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  每天十分钟，把瓜看明白
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                  合集按时间顺序整理当天话题，榜单按热度排出重点。没有夸张标题，也没有道听途说，只把能核实的信息讲清楚。
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/daily"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-newspaper-line text-base"></i>
                  </span>
                  浏览每日合集
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-accent-300 bg-background-50 px-6 py-3 text-sm font-medium text-accent-900 transition-colors duration-200 hover:bg-accent-100"
                >
                  了解内容原则
                </Link>
              </div>
            </div>
          </section>
        </div>
      </main>

      <SiteFooter />
      <BackToTop />
    </>
  );
}